<template>
  <div>
    <div class="form-check" v-if="currentPrivacyHints.length" ref="formCheck">
        <input class="form-check-input" type="checkbox" :id="'shipping-service-privacy-accept' + _uid" :checked="shippingPrivacyHintAccepted" @change="setValue($event.target.checked)">

        <label class="form-check-label" :for="'shipping-service-privacy-accept' + _uid">
            <div v-html="privacyHintContent"></div>
        </label>
    </div>

    <div v-else>
        <slot />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

const NotificationService = require("../../services/NotificationService");

export default {

    computed:
    {
        currentShippingProfile()
        {
            return this.shippingProfileList.find(profile => profile.parcelServicePresetId === this.shippingProfileId);
        },

        currentPrivacyHints()
        {
            if (this.currentShippingProfile && this.currentShippingProfile.shippingPrivacyInformation)
            {
                return this.currentShippingProfile.shippingPrivacyInformation.filter(entry => !!entry.showDataPrivacyAgreementHint);
            }

            return [];
        },

        privacyHintContent()
        {
            const andTranslation = this.$translate("Ceres::Template.checkoutShippingPrivacyHintAnd");
            let parcelServiceInformation = "";

            for (const hint of this.currentPrivacyHints)
            {
                if (parcelServiceInformation !== "")
                {
                    parcelServiceInformation += ` ${andTranslation} `;
                }

                parcelServiceInformation += `<strong>${hint.parcelServiceName}, ${hint.parcelServiceAddress}</strong>`;
            }

            return this.$translate("Ceres::Template.checkoutShippingPrivacyHint", { parcelServiceInformation });
        },

        ...mapState({
            shippingProfileList: state => state.checkout.shipping.shippingProfileList,
            shippingProfileId: state => state.checkout.shipping.shippingProfileId,
            shippingPrivacyHintAccepted: state => state.checkout.shippingPrivacyHintAccepted
        })
    },

    methods:
    {
        setValue(value)
        {
            this.$store.commit("setShippingPrivacyHintAccepted", value);
        }
    },

    watch:
    {
        currentShippingProfile(value, oldValue)
        {
            if (this.shippingPrivacyHintAccepted && value.parcelServiceId !== oldValue.parcelServiceId)
            {
                this.setValue(false);

                $(this.$refs.formCheck).fadeTo(100, 0.1).fadeTo(400, 1.0);

                NotificationService.error(this.$translate("Ceres::Template.checkoutShippingPrivacyReseted"));
            }
            else if (value && !value.shippingPrivacyInformation[0].showDataPrivacyAgreementHint)
            {
                this.setValue(false);
            }
        }
    }
}
</script>
